<template>
  <div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="mr-auto">
        <p class="text-uppercase text-dark font-weight-bold mb-1">
          Simulador de Vendas
        </p>
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-center">
      <b-form-group label="Merchant" label-for="Merchant" v-if="sysNonMerchantUser" class="col-12 pl-0 pr-0">



        <v-select label="name" :filterable="false" :options="merchants" :reduce="merchant => merchant.id"
          v-model="form.idMerchant" @search="onSearch">
          <template slot="no-options">Pesquisar Estabelecimento</template>
          <template slot="option" slot-scope="option">{{
            option.name
          }}</template>
          <template slot="selected-option" slot-scope="option">{{
            option.name
          }}</template>
        </v-select>

      </b-form-group>
      <b-form-group label="Valor da Venda" label-for="valor" class="col-12 pl-0 pr-0">
        <b-form-input id="valor" v-money="money" v-model="form.amount" required placeholder="Valor"></b-form-input>
      </b-form-group>

      <b-form-group label="Parcelas" label-for="parcels" class="col-12 pl-0 pr-0">
        <b-select v-model="form.parcels" ref="parcels">
          <b-select-option :value="null">
            Selecione
          </b-select-option>
          <b-select-option :value="index + 1" v-for="(item, index) in parcels" :key="`parcels-${index}`" required>
            {{ item }}
          </b-select-option>
        </b-select>
      </b-form-group>

      <b-form-group label="Tipo" label-for="tipo" class="col-12 pl-0 pr-0">
        <b-select v-model="form.cardType">
          <b-select-option value="">
            Selecione
          </b-select-option>
          <b-select-option :value="2" key="2">
            Crédito
          </b-select-option>
          <b-select-option :value="1" key="1">
            Débito
          </b-select-option>
        </b-select>
      </b-form-group>

      <b-form-group label="Bandeira" label-for="Bandeira" class="col-12 pl-0 pr-0">
        <b-select v-model="form.idCardIssuer">
          <b-select-option value="">
            Selecione
          </b-select-option>
          <b-select-option :value="item.idCardIssuer" v-for="(item, index) in issuerList" :key="`issuer-${index}`"
            required>
            {{ item.name }}
          </b-select-option>
        </b-select>

      </b-form-group>

      <b-form-group v-if="result != null" label="" label-for="description" class="col-12 pl-0 pr-0">
        <p>A taxa de operação é: <label style="font-weight: bold;" for=""> {{ result.tax }}% </label>
        <p>Se você vai pagar a taxa, vai receber </p>
        <label style="font-weight: bold;" for="">{{ result.sellerNetValue | money }} {{ form.parcels }}x de {{
          sellerParcel
          |
          money }} </label>
        <p style="font-weight: bold;" v-if="result.availableDays <= 2" for=""> Valor total disponível em
          {{ result.availableDays }} dia(s) </p>
        <p>Se o cliente vai pagar a taxa o valor cobrado é </p>
        <label style="font-weight: bold;" for="">{{ result.customerValue | money }} em {{ form.parcels }}x de {{
          customerParcel |
          money }} para receber {{ form.amount | money }}</label>
        <p style="font-weight: bold;" v-if="result.availableDays <= 2" for=""> Valor total disponível em
          {{ result.availableDays }} dia(s) </p>
      </b-form-group>
      <button :disable="loading" type="button" class="text-center btn btn-primary w-100 font-weight-bold font-size-18"
        @click="simulation()">
        Simular
      </button>
    </div>
  </div>
</template>
<script>
import { VMoney } from "v-money";
import { get as _get, debounce as _debounce } from "lodash";
import { MerchantNegotiationResource } from '@/resources/MerchantNegotiation.resource.js'
import { EmissorDeCartao } from '@/resources/EmissorDeCartao.resource.js'
export default {

  name: "ReceivementSimulation",
  data() {
    return {

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true
      },
      form: {
        amount: 0,
        parcels: 0,
        cardType: 0,
        idMerchant: 0,
        idAcquirer: 2 //TODO deixar com adquirente dinamico 

      },
      sellerParcel: 0,
      customerParcel: 0,
      result: null,
      parcels: ["1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x", "11x", "12x", "13x", "14x", "15x", "16x", "17x", "18x"],
      merchants: [],
      issuerList: [],
      loading: false
    };
  },
  directives: { money: VMoney },

  watch: {
    "form.cardType": function (v) {
      this.getCardIssuer(v);
    },
    "form.idMerchant": function (v) {
      this.result = null;
      if (this.cardType > 0) {
        this.getCardIssuer(this.cardType);

      }

    }
  },
  computed: {
    sysNonMerchantUser() {
      try {

        return (
          this.$store.getters.user.role
            .split(",")
            .filter(role => role !== "Merchant-Manager").length > 0
        );
      } catch (e) {
        return false;
      }
    },

  },
  methods: {

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search
          }
        })
        .then(result => {
          loading(false);
          vm.merchants = result.data.payload.map(item => ({
            id: item.id,
            name: item.description
          }));
        })
        .catch(e => {
          // Surpress
        });
    }, 350)
    ,
    unmaskMoney(value) {
      return (
        parseInt(
          (value + "")
            .replace(/R\$/gi, "")
            .replace(/\s/gi, "")
            .replace(/\./gi, "")
            .replace(/,/gi, "")
        ) / 100
      );
    },

    getCardIssuer(cardTypeItem) {
      const filter = {
        cardType: cardTypeItem,
        idMerchant: this.form.idMerchant

      }
      EmissorDeCartao.getByCardType(filter)
        .then((result) => {
          try {

            this.issuerList = result.data.payload;

          } catch (error) {
            throw {
              response: {
                data: {
                  failureReason:
                    "Erro ao solicitar os dados, por favor tente novamente"
                }
              }
            };
          }


        })
        .catch(e => {
          this.loading = false;
        });
    },

    simulation() {
      const data = {
        ...this.form

      }

      data.amount = this.unmaskMoney(data.amount);

      MerchantNegotiationResource.simulationTax(data)
        .then(response => {
          if (response.data.isSuccess) {
            this.loading = false;
            this.result = response.data.payload;
            this.sellerParcel = data.amount / this.form.parcels;
            this.customerParcel = this.result.customerValue / this.form.parcels;
          }
          else {
            throw "Erro ao editar política comercial";
          }
        })

    }
  },


};
</script>
